"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AppDispatcher } from 'Dispatcher';
import StoreClass from 'Store';
import { FormSettingsConstants } from 'Constants/Forms/FormSettingsConstants';
import { ApplicationConstants } from "Constants/ApplicationConstants";
import { Fields, System } from "Constants/objects";
import { Map, Record } from "immutable";
import { formDestroyed, formSubmit } from "Actions/Forms/FormActions";
import { formSettingsUpdate } from "Actions/Forms/FormSettingsActions";
import { Messages } from "Messages";
import { LANGUAGE_BY_LOCALE } from "Constants/lang_by_locale";
import { FormConstants } from "Constants/Forms/FormConstants";
import { UserSettings } from "D5Utils/UserSettings";
import { user } from "Models/UserModel";
var SettingsStore = Record({
  initialized: false,
  title: '',
  formInst: null,
  popupInst: null,
  updating: false,
  settings: null,
  formData: null
});

var _stores = Map();

var CHANGE_EVENT = 'change';

var FormSettingsStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(FormSettingsStoreClass, _StoreClass);

  function FormSettingsStoreClass() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FormSettingsStoreClass);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormSettingsStoreClass)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "SettingsRec", function () {
      var regionalSettings = UserSettings.getRegionalSettings();
      return Record({
        common: {
          itemType: "group",
          items: [{
            dataField: Fields.AppLang,
            editorType: "dxSelectBox",
            label: {
              location: 'top',
              text: Messages.Controls.ApplicationLanguage
            },
            editorOptions: {
              displayExpr: 'text',
              valueExpr: 'id',
              items: [{
                id: 'ru',
                text: 'ru'
              }, {
                id: 'en',
                text: 'en'
              }],
              value: UserSettings.getApplicationLang()
            }
          }, {
            itemType: "button",
            horizontalAlignment: "left",
            buttonOptions: {
              text: Messages.Controls.ResetAllSettings,
              hint: Messages.Controls.ResetAllSettingsHint,
              type: "danger",
              onClick: function onClick() {
                _this.confirmResetAllSettings().then(function (result) {
                  if (result) {
                    var toRemove = [];

                    for (var i = 0; i < localStorage.length; i++) {
                      if (localStorage.key(i).indexOf(user.getUserID()) === 0) {
                        toRemove.push(localStorage.key(i));
                      }
                    }

                    for (var _i = 0; _i < toRemove.length; _i++) {
                      localStorage.removeItem(toRemove[_i]);
                    }

                    document.location.reload();
                  }
                });
              }
            }
          }]
        },
        regional: {
          itemType: "group",
          caption: Messages.Controls.RegionalSettings,
          items: [{
            label: {
              text: Messages.Controls.Format,
              visible: true
            },
            dataField: Fields.RegionalLocale,
            editorType: "dxSelectBox",
            editorOptions: {
              dataSource: new DevExpress.data.DataSource({
                store: LANGUAGE_BY_LOCALE,
                key: "id",
                paginate: true,
                pageSize: 20
              }),
              value: regionalSettings[Fields.RegionalLocale],
              displayExpr: 'name',
              valueExpr: 'id',
              showClearButton: true,
              searchEnabled: true
            }
          }]
        }
      });
    });

    return _this;
  }

  _createClass(FormSettingsStoreClass, [{
    key: "getInitList",
    value: function getInitList() {
      return new SettingsStore().toObject();
    }
    /**
     * @return {*|Map<any, any>|Map<string, string>}
     */

  }, {
    key: "getList",
    value: function getList(uuid) {
      return _stores.get(uuid).toObject();
    }
  }, {
    key: "navigateToParent",
    value: function navigateToParent(UUID) {
      setTimeout(function () {
        return formDestroyed(UUID);
      });
    }
  }, {
    key: "_CommonPage",
    value: function _CommonPage(UUID) {
      return this.store(UUID).get('settings').common;
    }
  }, {
    key: "_RegionalPage",
    value: function _RegionalPage(UUID) {
      return this.store(UUID).get('settings').regional;
    }
  }, {
    key: "_MainPanel",
    value: function _MainPanel(UUID) {
      return {
        itemType: "group",
        items: [{
          itemType: "tabbed",
          tabPanelOptions: {
            deferRendering: false
          },
          tabs: [{
            title: Messages.Controls.RegionalSettings,
            items: [this._RegionalPage(UUID)]
          }, {
            title: Messages.Controls.CommonSettings,
            items: [this._CommonPage(UUID)]
          }]
        }]
      };
    }
  }, {
    key: "store",
    value: function store(UUID) {
      return _stores.get(UUID);
    }
  }, {
    key: "initForm",
    value: function initForm(_ref) {
      var UUID = _ref.UUID;
      var that = this;
      var store = this.store(UUID);
      var form = $(store.get('formInst')).dxForm({
        // formData: data,
        items: [this._MainPanel(UUID)],
        labelLocation: 'top',
        tabIndex: -1,
        onEditorEnterKey: function onEditorEnterKey(e) {
          if (e.event.ctrlKey && e.event.keyCode === 13) {
            //Ctrl+Enter
            e.component.getEditor(e.dataField).blur(); //для того чтобы обновилось значение поля

            formSubmit(UUID);
          }
        },
        onContentReady: function onContentReady(e) {
          var _this2 = this;

          //таймаут потому что форма загружается раньше чем показывается попап, взято из примера поддержки либы
          setTimeout(function () {
            var store = _stores.get(UUID);

            var $elements = _this2.element().find('input,select,textarea');

            $("#fe-title-".concat(UUID)).html(store.get('title'));

            for (var i = 0; i < $elements.length; ++i) {
              var editor = _this2.getEditor($elements[i].name);

              if (editor && !editor.option('disabled') && editor.option('visible')) {
                editor.focus();
                break;
              }
            }

            store = store.set('initialized', true);
            _stores = _stores.set(UUID, store);
            that.emit(CHANGE_EVENT);
          }, 600);
        }
      });
      store = store.set('formInst', form);

      if (store.get('popupInst')) {
        store.get('popupInst').dxPopup("show");
      }

      _stores = _stores.set(UUID, store);
    }
  }, {
    key: "updateForm",
    value: function updateForm(_ref2) {
      var UUID = _ref2.UUID;
    }
  }, {
    key: "cancelForm",
    value: function cancelForm(UUID) {
      if (this.store(UUID)) {
        this.store(UUID).get('popupInst').dxPopup('hide');
        FormSettingsStore.navigateToParent(UUID);
      }
    }
  }, {
    key: "apply",
    value: function apply(_ref3) {
      var _this3 = this;

      var formUUID = _ref3.formUUID;
      this.saveSettings(formUUID);
      setTimeout(function () {
        _this3.cancelForm(formUUID);
      });
    }
  }, {
    key: "destroy",
    value: function destroy(UUID) {
      if (UUID != null) _stores.delete(UUID);else _stores.clear();
    }
  }, {
    key: "_saveRegionalData",
    value: function _saveRegionalData(UUID) {
      var formData = this.store(UUID).get('formInst').dxForm('option', 'formData');
      var regionalSettings = UserSettings.getRegionalSettings();
      regionalSettings[Fields.RegionalLocale] = formData[Fields.RegionalLocale];
      UserSettings.setSettings(System.USER_SETTINGS.REGIONAL_SETTINGS, regionalSettings);
    }
  }, {
    key: "_saveAppLang",
    value: function _saveAppLang(UUID) {
      var formData = this.store(UUID).get('formInst').dxForm('option', 'formData');
      UserSettings.setSettings(System.USER_SETTINGS.APPLICATION_LANG, formData[Fields.AppLang]);
    }
  }, {
    key: "saveSettings",
    value: function saveSettings(UUID) {
      this._saveRegionalData(UUID);

      this._saveAppLang(UUID);

      document.location.reload();
    }
  }, {
    key: "confirmResetAllSettings",
    value: function confirmResetAllSettings() {
      return DevExpress.ui.dialog.custom({
        message: Messages.Confirm.ResetAllSettings,
        title: Messages.Controls.Confirmation,
        buttons: [{
          text: Messages.Controls.Yes,
          onClick: function onClick() {
            return true;
          }
        }, {
          text: Messages.Controls.No,
          onClick: function onClick() {
            return false;
          }
        }]
      }).show();
    }
  }]);

  return FormSettingsStoreClass;
}(StoreClass);

var FormSettingsStore = new FormSettingsStoreClass();
AppDispatcher.register(function (action) {
  var st = FormSettingsStore;
  var store = {};

  switch (action.actionType) {
    case FormSettingsConstants.FORM_SETTINGS_INITIALIZE:
      var UUID = action.formObj.UUID;
      var SettingsRec = st.SettingsRec();
      _stores = _stores.set(UUID, new SettingsStore({
        formInst: action.formInst,
        popupInst: action.popupInst,
        settings: new SettingsRec(),
        title: 'Settings'
      }));
      setTimeout(function () {
        return formSettingsUpdate({
          UUID: UUID
        });
      });
      break;

    case FormConstants.NAVIGATE_TO_PARENT:
      if (!st.store(action.formUUID)) return true;
      st.cancelForm(action.formUUID);
      break;

    case FormSettingsConstants.FORM_SETTINGS_UPDATE:
      if ($(st.store(action.UUID).get('formInst')).data('dxForm')) {
        st.updateForm(action);
      } else {
        st.initForm(action);
      }

      store = st.store(action.UUID);
      _stores = _stores.set(action.UUID, store.set('updating', false));
      break;

    case FormConstants.FORM_SUBMIT:
      if (!st.store(action.formUUID)) return true;
      st.apply(action);
      break;

    case ApplicationConstants.DO_LOGOUT:
      {
        st.destroy();
        break;
      }

    default:
      return true;
  }
});
export default FormSettingsStore;